// extracted by mini-css-extract-plugin
module.exports = {"heading":"independent-sync-licensing-module--heading--1WIgY","description":"independent-sync-licensing-module--description--2VPFl"};